import React from "react";
import { Link } from "react-router-dom";
import className from "classnames/bind";
import useTranslations from "../../hooks/useTranslations";

/**
 * Component hiển thị các nút hành động sau thanh toán
 * @param {Object} props
 * @param {boolean} props.isPaymentSuccess - Thanh toán thành công
 * @param {boolean} props.isPaymentFailed - Thanh toán thất bại
 * @param {boolean} props.isCODOrder - Đơn hàng COD
 * @param {Object} props.styles - SCSS styles object
 */
const PaymentActions = ({ 
  isPaymentSuccess, 
  isPaymentFailed, 
  isCODOrder, 
  styles 
}) => {
  const cx = className.bind(styles);
  const translations = useTranslations();

  // Hiển thị cho thanh toán thành công hoặc COD
  if (isPaymentSuccess || isCODOrder) {
    return (
      <div className={cx("actions")}>
        <div className={cx("success-actions")}>
          <Link to="/" className={cx("back-to-shopping")}>
            {translations?.PaymentSuccess?.back || "BACK TO SHOPPING"}
          </Link>
        </div>
      </div>
    );
  }

  // Hiển thị cho thanh toán thất bại
  if (isPaymentFailed) {
    return (
      <div className={cx("actions")}>
        <div className={cx("failed-actions")}>
          <Link to="/checkout" className={cx("retry-payment")}>
            {translations?.PaymentFailed?.try_again || "TRY AGAIN"}
          </Link>
          <Link to="/" className={cx("back-to-shopping")}>
            {translations?.PaymentSuccess?.back || "BACK TO SHOPPING"}
          </Link>
        </div>
      </div>
    );
  }

  // Hiển thị cho trạng thái đang xử lý
  return (
    <div className={cx("actions")}>
      <div className={cx("pending-actions")}>
        <button
          className={cx("refresh-button")}
          onClick={() => window.location.reload()}
        >
          REFRESH STATUS
        </button>
        <Link to="/" className={cx("back-to-shopping")}>
          {translations?.PaymentSuccess?.back || "BACK TO SHOPPING"}
        </Link>
      </div>
    </div>
  );
};

export default PaymentActions;
